"use client";

import { useState, useEffect } from "react";

export function useLoginLabel() {
  const [label, setLabel] = useState("Log in / Sign up");
  useEffect(() => {
    setLabel(localStorage.getItem("last-login-provider") ? "Log in" : "Sign up");
  }, []);
  return label;
}
